import React from "react";
import { env } from "build/env";
export function distance(lat1, lng1, lat2, lng2) {
  const R = 6378137; // Radius of the Earth in meters
  const rlat1 = lat1 * (Math.PI / 180); // Convert degrees to radians
  const rlat2 = lat2 * (Math.PI / 180); // Convert degrees to radians
  const difflat = rlat2 - rlat1; // Radian difference (latitudes)
  const difflon = (lng2 - lng1) * (Math.PI / 180); // Radian difference (longitudes)

  const d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat / 2) * Math.sin(difflat / 2) + Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflon / 2) * Math.sin(difflon / 2)));
  return d;
}
export const isExternalLink = url => {
  return /^(http|https):\/\//.test(url);
};
export function isEveryValueNotEmpty(obj) {
  if (obj === null || obj === undefined) return false;
  if (Object.keys(obj).length === 0) return false;
  return Object.values(obj).every(value => {
    return value !== null && value !== undefined && value !== "";
  });
}
export const removeAtIndex = (arr, index) => {
  const copy = [...arr];
  copy.splice(index, 1);
  return copy;
};
export const toggle = function (arr, item) {
  let getValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : item => item;
  const index = arr.findIndex(i => getValue(i) === getValue(item));
  if (index === -1) return [...arr, item];
  return removeAtIndex(arr, index);
};
export const handleDisabledButtonClick = () => {
  // Select all elements with the specified class
  const elements = document.querySelectorAll(".shake-incomplete");

  // Add the shake animation class to each element
  elements.forEach(element => {
    element.classList.add("uk-animation-shake");

    // Remove the class after the animation duration (assuming 1s for example)
    setTimeout(() => {
      element.classList.remove("uk-animation-shake");
    }, 1000); // Adjust time to match the duration of the uk-animation-shake
  });
};
export const replaceAllOccurrences = function (str, searchValue, replaceValue) {
  let escapeRegex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  if (escapeRegex) {
    return str.replace(new RegExp(escapeRegExp(searchValue), "g"), replaceValue);
  } else {
    return str.replace(new RegExp(searchValue, "g"), replaceValue);
  }
};

// Utility function to escape special characters for the regular expression
function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}

// Function to replace the Magento backend URL with the image base URL
export const cdnImageUrl = src => {
  if (src && env.IMAGE_BASE_URL) {
    if (src.startsWith("/media/catalog")) {
      src = env.IMAGE_BASE_URL + src;
    }
    const baseUrl = replaceAllOccurrences(src, env.MAGENTO_BACKEND_URL, env.IMAGE_BASE_URL);
    const cleanPub = replaceAllOccurrences(baseUrl, "\/pub\/media\/", "\/media\/", false);
    src = replaceAllOccurrences(cleanPub, "\/\/media", "\/media", false);
  }
  return src;
};
export const bgImage = src => "url(\"".concat(cdnImageUrl(src), "\")");
export function getCarouselSlides(carousel, isMobile) {
  const itemsSlider = carousel ? carousel.slides : null;
  const slider = itemsSlider && itemsSlider.map((item, i) => ({
    id: item.slide_id,
    backgroundImage: bgImage(item.mobile_image && isMobile ? item.mobile_image : item.desktop_image),
    title: item.heading_text,
    subtitle: item.subtitle_text,
    cta_text: item.cta_text,
    cta_url: item.cta_url,
    video: item.mobile_video && isMobile ? item.mobile_video : item.desktop_video
  }));
  return [itemsSlider, slider];
}
export const getArrayIntersection = arrays => {
  if (arrays.length === 0) {
    return [];
  }
  const result = arrays.shift().filter(function (v) {
    return arrays.every(function (a) {
      return a.indexOf(v) !== -1;
    });
  });
  return result;
};
export const arraysHaveSameItems = (a, b) => {
  const uniqueA = new Set(a);
  const uniqueB = new Set(b);
  if (uniqueA.size !== uniqueB.size) return false;
  for (let item of uniqueA) {
    if (!uniqueB.has(item)) {
      return false;
    }
  }
  return true;
};
export function parseJwt(token) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(window.atob(base64).split("").map(function (c) {
    return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(""));
  return JSON.parse(jsonPayload);
}
export const compareArrays = (a, b) => a.length === b.length && a.every(v => b.includes(v));
export const isArraySubset = (a, b) => a.every(val => b.includes(val));

/**
 * Splits a string on an explicit delimiter character (default "\") and
 * renders each segment on its own line. When the delimiter is absent,
 * the input is returned unchanged so natural CSS wrapping still applies.
 *
 * Useful for content-driven titles where an editor wants to control the
 * exact break point, e.g. `"Spaghetti\alla carbonara"` → "Spaghetti"
 * on line 1, "alla carbonara" on line 2.
 */
export const renderWithLineBreaks = function (text) {
  let delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "\\";
  if (!text) return "";
  const str = String(text);
  if (!str.includes(delimiter)) return str;
  const parts = str.split(delimiter).map(part => part.trim()).filter(Boolean);
  if (parts.length <= 1) return parts[0] || "";
  return /*#__PURE__*/React.createElement(React.Fragment, null, parts.map((part, i) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: i
  }, i > 0 ? /*#__PURE__*/React.createElement("br", null) : null, part)));
};

/**
 * Prefer Magento `\` breaks; otherwise insert a break after "Baby Trofie"
 * so Kids cards keep a stable first line.
 */
export const formatBabyTrofieTitleForBreaks = function (text) {
  let delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "\\";
  if (!text) return "";
  const str = String(text);
  if (str.includes(delimiter)) {
    return str;
  }
  const match = str.match(/^(baby\s+trofie)\s+/i);
  if (!match) {
    return str;
  }
  return "".concat(match[1]).concat(delimiter).concat(str.slice(match[0].length).trim());
};
export const renderKidsDetailTitle = text => {
  return renderWithLineBreaks(formatBabyTrofieTitleForBreaks(text));
};
export const breakLineIfExceedsLimit = (text, limit) => {
  if (!text) return "";
  const words = text.split(" ");
  let sum = 0;
  let breakIndex = -1;
  if (words[0].length >= limit) {
    breakIndex = 1; // If the first word equals or exceeds the limit, break after it
  } else {
    for (let index = 0; index < words.length; index++) {
      let newSum = sum + words[index].length + (index > 0 ? 1 : 0); // Add 1 for the space

      if (newSum > limit) {
        breakIndex = index;
        break;
      }
      if (index < words.length - 1 && words[index + 1].length <= 3) {
        let futureSum = newSum + words[index + 1].length + 1; // Sum considering the next word
        let remainingLength = text.length - futureSum; // Total length of the remaining text

        if (futureSum > remainingLength) {
          breakIndex = index + 1;
          break;
        }
      }
      sum = newSum;
    }
  }
  if (breakIndex === -1) {
    return text; // No need to break the line
  }
  const firstLine = words.slice(0, breakIndex).join(" ");
  const secondLine = words.slice(breakIndex).join(" ");
  return /*#__PURE__*/React.createElement("div", null, firstLine, /*#__PURE__*/React.createElement("br", null), secondLine);
};
export const goToAllergens = function () {
  let link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "https://magento-s3.miscusi.com/other/allergeni.pdf";
  window.open(link, "_blank");
};
export function getRandom(arr, n) {
  var result = new Array(n),
    len = arr.length,
    taken = new Array(len);
  if (n > len) return arr.slice();
  while (n--) {
    var x = Math.floor(Math.random() * len);
    result[n] = arr[x in taken ? taken[x] : x];
    taken[x] = --len in taken ? taken[len] : len;
  }
  return result;
}
export const removeBasenameFromPath = function () {
  let path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  let string = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  if (path.startsWith(string)) {
    return path.substring(string.length);
  }
  return path;
};
export const isEmailValid = value => {
  if (!value) return false;
  return value.trim().match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) && !value.trim().endsWith(".con") && (value.trim().includes("@gmail.") ? value.trim().endsWith("@gmail.com") : true);
};
export const isPasswordValid = value => {
  if (!value) return false;
  const regex = new RegExp("(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!$*?@]).{8,}", "g");
  return regex.test(value);
};
export const isTelephoneNumberValid = value => {
  const stringValue = value === null || value === void 0 ? void 0 : value.toString();
  if (!stringValue) return false;
  return stringValue.trim().match(/^\+?([0-9]{1,3})?[-. ]?(\\([0-9]{1,3}\\)|[0-9]{1,3})[-. ]?([0-9]{1,4})[-. ]?([0-9]{1,4})[-. ]?([0-9]{1,4})$/) ? true : false;
};
export const isImgUrl = url => {
  return /\.(jpg|jpeg|png|gif|bmp|svg)$/i.test(url);
};
export function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
;
export const hash = function (str) {
  let seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (!str) return null;
  let h1 = 0xdeadbeef ^ seed,
    h2 = 0x41c6ce57 ^ seed;
  for (let i = 0, ch; i < str.length; i++) {
    ch = str.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ h1 >>> 16, 2246822507);
  h1 ^= Math.imul(h2 ^ h2 >>> 13, 3266489909);
  h2 = Math.imul(h2 ^ h2 >>> 16, 2246822507);
  h2 ^= Math.imul(h1 ^ h1 >>> 13, 3266489909);

  //return 4294967296 * (2097151 & h2) + (h1 >>> 0);
  return (h2 >>> 0).toString(16).padStart(8, 0) + (h1 >>> 0).toString(16).padStart(8, 0);
};
export const hashObject = function (obj) {
  let seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return hash(JSON.stringify(obj), seed);
};
export const castToCorrectType = (value, key) => {
  if (key.endsWith("Sku")) return value;
  if (key === "gmbLocationId") return value; // Keep as string to avoid precision loss with large IDs
  if (value.startsWith("00")) return value;
  if (value === "true") return true;
  if (value === "false") return false;
  if (!isNaN(value) && value.trim() !== "") return Number(value);
  try {
    const parsed = JSON.parse(value);
    if (typeof parsed === "object") return parsed;
  } catch (e) {
    // Ignore JSON.parse errors and return the original string
  }
  return value;
};